import type { DialogueContent } from '../../interactions/dialogue';
import type { InspectContent } from '../../interactions/inspect';
import type { SceneDefinition } from '../scene.types';

export const reserveInspections: Record<string, InspectContent> = {
  'reserve.echelle': {
    title: 'L’échelle de la réserve',
    lines: [
      'Elle sert à atteindre la dernière étagère. Personne n’a jamais eu besoin d’y monter.',
      'En haut, uniquement des cartons vides et une raquette de tennis inexpliquée.',
      'Le règlement interdit aux chiens de l’emprunter. Le règlement est optimiste.',
    ],
  },
};

export const reserveDialogues: DialogueContent[] = [
  {
    id: 'reserve.entry',
    lines: [
      'La réserve. Tout ce que la boutique possède est ici, rangé par catégories. Provisoirement.',
    ],
    character: 'La boutique',
    once: true,
  },
  {
    id: 'reserve.caisses',
    lines: [
      'Les caisses du fond attendent d’être ouvertes depuis mardi.',
      'Quelqu’un a écrit « fragile » sur une caisse de cornes de buffle.',
    ],
  },
  {
    id: 'reserve.bone',
    lines: ['Il y avait un os derrière cette caisse. Évidemment.'],
  },
];

export const reserveScene: SceneDefinition = {
  id: 'reserve',
  title: 'La Réserve',
  background: '/scenes/scene-reserve-background-v2.webp',
  entryDialogueId: 'reserve.entry',
  layers: [],
  /**
   * Les 148 produits du catalogue ne peuvent pas être posés à la main :
   * cette étagère se remplit depuis les collections Shopify, douze par page.
   */
  shelf: {
    x: 16.5,
    y: 22,
    width: 53.7,
    height: 34,
    columns: 4,
    rows: 3,
    mobileColumns: 2,
    mobileRows: 3,
    collections: [
      { handle: 'produits-mastication', label: 'Mastication' },
      { handle: 'friandises-dentaires', label: 'Friandises' },
      { handle: 'jouets-chiens', label: 'Jouets' },
      { handle: 'tapis-de-lechage-chiens', label: 'Tapis de léchage' },
      { handle: 'packs', label: 'Packs' },
      { handle: 'nouveautes', label: 'Nouveautés' },
    ],
  },
  hotspots: [
    {
      id: 'reserve.echelle',
      label: 'Examiner l’échelle de bibliothèque',
      action: 'inspect',
      target: 'reserve.echelle',
      x: 71,
      y: 20,
      width: 12,
      height: 55,
      hint: 'L’échelle',
      simplifiedLabel: 'Examiner l’échelle',
    },
    {
      id: 'reserve.caisses',
      label: 'Ouvrir les caisses empilées',
      action: 'animation',
      target: 'reserve.caisses',
      x: 17,
      y: 66,
      width: 20,
      height: 14,
      hint: 'Les caisses',
      simplifiedLabel: 'Ouvrir les caisses',
    },
    {
      id: 'reserve.to-galerie',
      label: 'Entrer dans la grande allée',
      action: 'navigate',
      target: 'galerie',
      x: 86,
      y: 20,
      width: 12,
      height: 44,
      hint: 'La grande allée',
      simplifiedLabel: 'Entrer dans la grande allée',
    },
    {
      id: 'reserve.to-comptoir',
      label: 'Retourner au Comptoir',
      action: 'navigate',
      target: 'comptoir',
      x: 2,
      y: 30,
      width: 11,
      height: 34,
      hint: 'Le Comptoir',
      simplifiedLabel: 'Retourner au Comptoir',
    },
  ],
};
